import InfoTooltip from '@/components/Tooltip/InfoTooltip';
import { Box } from '@mui/material';

interface IProps {
  label: string;
  tooltipValue?: string;
}

const TotalsCardHeader = ({ label, tooltipValue }: IProps) => {
  return (
    <Box sx={{ position: 'relative', display: 'flex', alignContent: 'center', gap: '4px' }}>
      <span>{label}</span>
      {tooltipValue && <InfoTooltip maxWidth={450} title={tooltipValue} />}
    </Box>
  );
};

export default TotalsCardHeader;
